/**
 * Created by neo on 25.02.17.
 */
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import Flight from '../../Store/Flight';
import { Container, Row, Col, Button } from 'reactstrap';
import { translate  } from 'react-i18next';
import FlightRoute from './FlightRoute';
import Booking from './Booking';
import FlightBookingRequest from '../../Store/Booking/FlightBookingRequest';
import LanguageStore from '../../../lang';
import DisplayToggle from '../../Components/DisplayToggle';
import MobileBooking from './Booking/Mobile';
import GalleryHeader from '../../Components/GalleryHeader'

type Props = {
  params: any
};

@observer
export class FlightViewScreen extends Component {

  props: Props;

  state: {
    flight: Flight,
    loading: boolean,
    booking: FlightBookingRequest,
    showMobileBooking: boolean,
  };

  constructor(props: Props) {
    super(props);
    const flight = new Flight();
    this.state = {
      flight,
      loading: true,
      booking: new FlightBookingRequest({ flight }),
      showMobileBooking: false
    };
  }

  componentWillMount() {
    if(this.props.params.flightId) {
      Flight.get(this.props.params.flightId, LanguageStore.lang).then((flight: Flight) => {
        const booking = new FlightBookingRequest({ flight });
        booking.setPassengerCount(1);
        this.setState({ flight, loading: false, booking });
      });
    }
  }

  handleBooking = (bookingRequest: FlightBookingRequest) => {
    const passengerCount = bookingRequest.passengerCount;
    const params = `passengers=${passengerCount}`;
    this.props.router.push(`/booking/flight/${this.state.flight.id}?${params}`);
  };

  handleMobileBooking = () => {
    this.setState({ showMobileBooking: true });
  };

  handleCloseMobileBooking = () => {
    this.setState({ showMobileBooking: false });
  };

  render() {
    if(this.state.loading) {
      return null;
    }

    const { t } = this.props;
    const { flight, showMobileBooking, booking } = this.state;

    return (
      <div>
        <GalleryHeader title={flight.aircraft_offer.flight_offer.title} medias={flight.aircraft_offer.flight_offer.files} />
        <Container  style={{paddingTop: 50}}>
          <Row>
            <Col xs={12} md="7" lg="8" style={{padding:30}}>
              <Row>
                <Col>
                  <h2>{t('Description')}</h2>
                  <p className='lead' style={{whiteSpace: 'pre-line'}}>
                    {flight.aircraft_offer.flight_offer.description || t('Diesem Flug wurde noch keine Beschreibung hinzugefügt')}
                  </p>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col>
                  <h2>{t('Flugroute')}</h2>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FlightRoute flight={this.state.flight}/>
                </Col>
              </Row>
            </Col>
            <Col md="5" lg="4" className="booking-side">
              <Booking
                flight={flight}
                booking={booking}
                onBook={this.handleBooking}
              />
            </Col>
          </Row>
          <DisplayToggle show={showMobileBooking}>
            <MobileBooking
              flight={flight}
              booking={booking}
              onBook={this.handleBooking}
              onClose={this.handleCloseMobileBooking}
            />
          </DisplayToggle>
          <div className="large booking-button">
            <Button color="primary" block onClick={this.handleMobileBooking}>{t('Buchen')}</Button>
          </div>
        </Container>
      </div>
    );
  }
}

export default translate ()(FlightViewScreen);



// WEBPACK FOOTER //
// ./src/App/Flight/View/index.js